<template>
  <v-container fluid>
      <v-row class="my-10">
        <v-col class="text-center">
          <h1>路段列表</h1>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="text-center">
          <v-simple-table>
            <template v-slot:default>
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.name"
                >
                  <td @click="onRoad(item.code, item.name, item.filters)" :data-id="item.code">{{ `${item.code} ${item.name}` }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
export default {
  created() { 
    this.loadSiteInfo()
  },
  computed: {
    items() {
      return this.$store.state.roadList;
    }
  },
  methods: {
    loadSiteInfo() {
      this.axios.get('api/site').then((resp) => {
        this.$store.commit("SetSiteName", resp.data.name);
        this.$store.commit("SetRoadList", resp.data.roads);
      })
    },
    onRoad(id, name, filters) {
      console.log(filters);
      this.$store.commit("SetRoad", {id: id, name: name, filters: filters});
      this.$router.push({name: 'road'})
    }
  },
};
</script>
